export default function AboutHero() {
  return (
    <section className="relative min-h-[80vh] flex items-center justify-center overflow-hidden" style={{ background: '#0f0f0f' }}>
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/83c7a310a76fcac8e36bcd5cf86a315b.jpg"
          alt="Hometown Painters craftsmanship Elk Grove Village Illinois"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-charcoal-900/75 via-charcoal-900/55 to-charcoal-900/85" />
      </div>
      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-6 flex flex-col items-center text-center">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-12 h-px bg-gold" />
          <span className="font-sans text-gold text-xs tracking-[0.3em] uppercase">Our Story · Elk Grove Village, IL</span>
          <span className="w-12 h-px bg-gold" />
        </div>
        <h1 className="font-serif text-warm-white text-5xl md:text-6xl leading-tight mb-6 max-w-3xl">
          A Local Painting Company<br />
          <em className="text-gold not-italic">Focused on Craftsmanship</em>
        </h1>
        <p className="font-sans text-warm-muted text-base md:text-lg leading-relaxed max-w-2xl mb-10">
          Hometown Painters has been serving Elk Grove Village and the Chicago suburbs with premium residential
          and commercial painting services, built on quality workmanship and honest communication.
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <a href="#quote" onClick={(e) => { e.preventDefault(); document.getElementById('quote')?.scrollIntoView({ behavior: 'smooth' }); }}
            className="bg-gold text-charcoal-900 font-sans font-medium text-sm px-8 py-4 rounded-full hover:bg-gold-light transition-all duration-300 hover:-translate-y-1 cursor-pointer whitespace-nowrap">
            Get a Free Estimate
          </a>
          <a href="tel:8478701600"
            className="flex items-center gap-2 border border-warm-white/40 text-warm-white font-sans text-sm px-8 py-4 rounded-full hover:border-gold hover:text-gold transition-all duration-300 cursor-pointer whitespace-nowrap">
            <div className="w-4 h-4 flex items-center justify-center"><i className="ri-phone-line" style={{ fontSize: '14px' }} /></div>
            (847) 870-1600
          </a>
        </div>
      </div>
    </section>
  );
}
